export default {
  // 养护合同
  insertContract: '/business/contract/insertContract',
  updateContract: '/business/contract/updateContract',
  deleteContract: '/business/contract/deleteContract',
  selectContractByContractId: '/business/contract/selectContractByContractId',
  selectContractList: '/business/contract/selectContractList',
  selectContractByPage: '/business/contract/selectContractByPage',
  selectPlanBackListByContractId: '/business/contract/selectPlanBackListByContractId',
  selectMinContractStartYm: '/business/contract/selectMinContractStartYm',
  // 成本计划
  insertPlanCost: '/business/planCost/insertPlanCost',
  deletePlanCost: '/business/planCost/deletePlanCost',
  selectPlanCostByPage: '/business/planCost/selectPlanCostByPage',
  // 成本计划明细
  updatePlanCostDetail: '/business/planCostDetail/updatePlanCostDetail',
  deletePlanCostDetail: '/business/planCostDetail/deletePlanCostDetail',
  selectPlanCostDetailByDetailId: '/business/planCostDetail/selectPlanCostDetailByDetailId',
  selectPlanCostDetailByPage: '/business/planCostDetail/selectPlanCostDetailByPage',
  // 间接费
  insertIndirect: '/business/indirect/insertIndirect',
  updateIndirect: '/business/indirect/updateIndirect',
  deleteIndirect: '/business/indirect/deleteIndirect',
  selectIndirectByIndirectId: '/business/indirect/selectIndirectByIndirectId',
  selectIndirectByPage: '/business/indirect/selectIndirectByPage',
  // 回款管理
  insertBack: '/business/back/insertBack',
  updateBack: '/business/back/updateBack',
  deleteBack: '/business/back/deleteBack',
  selectBackByBackId: '/business/back/selectBackByBackId',
  selectBackByPage: '/business/back/selectBackByPage',
  // 项目经营屏
  selectProject: '/business/projectStatistic/selectProject',
  selectCurrentMonth: '/business/projectStatistic/selectCurrentMonth',
  selectCurrentYear: '/business/projectStatistic/selectCurrentYear',
  selectAllYear: '/business/projectStatistic/selectAllYear',
  // 经营总览
  selectRevenue: '/business/operateStatistic/selectRevenue',
  selectCost: '/business/operateStatistic/selectCost',
  selectRevenueMonthList: '/business/operateStatistic/selectRevenueMonthList',
  selectProfit: '/business/operateStatistic/selectProfit',
  selectBack: '/business/operateStatistic/selectBack',
  selectCostTypeProjectVs: '/business/operateStatistic/selectCostTypeProjectVs',
  selectProfitMonthVs: '/business/operateStatistic/selectProfitMonthVs',
  selectCostTypeMonthVs: '/business/operateStatistic/selectCostTypeMonthVs',
  selectProfitProjectVs: '/business/operateStatistic/selectProfitProjectVs',
  selectProjectCostTypeVs: '/business/operateStatistic/selectProjectCostTypeVs',
  selectBackMonthVs: '/business/operateStatistic/selectBackMonthVs',
  selectBackProjectVs: '/business/operateStatistic/selectBackProjectVs',
  // 人工成本统计
  insertAllPersonCostReport: '/business/personCostReport/insertAllPersonCostReport',
  updatePersonCostReport: '/business/personCostReport/updatePersonCostReport',
  deletePersonCostReport: '/business/personCostReport/deletePersonCostReport',
  selectPersonCostReportByReportId: '/business/personCostReport/selectPersonCostReportByReportId',
  selectPersonCostReportByPage: '/business/personCostReport/selectPersonCostReportByPage',
  selectPersonCostTypeSum: '/business/personCostReport/selectPersonCostTypeSum',
  exportData: '/business/personCostReport/exportData'
}
